import { useMemo } from "react"
import Table from "../../components/table/Table"

const TrainingReportTableView = ({ data }) => {
    // Format cell value: show "-" for null/undefined
    const formatCell = (value) => value ?? "-"

    const columns = useMemo(
        () => [
            {
                Header: "Epoch",
                accessor: "epoch",
            },
            {
                Header: "Training",
                columns: [
                    { Header: "LR", accessor: "tr_lr", Cell: ({ value }) => formatCell(value) },
                    { Header: "Loss", accessor: "tr_loss", Cell: ({ value }) => formatCell(value) },
                    { Header: "Precision", accessor: "tr_precision", Cell: ({ value }) => formatCell(value) },
                    { Header: "Recall", accessor: "tr_recall", Cell: ({ value }) => formatCell(value) },
                    { Header: "F-Score", accessor: "tr_fscore", Cell: ({ value }) => formatCell(value) },
                    { Header: "Time", accessor: "tr_time", Cell: ({ value }) => formatCell(value) },
                ]
            },
            {
                Header: "Validation",
                columns: [
                    { Header: "Loss", accessor: "val_loss", Cell: ({ value }) => formatCell(value) },
                    { Header: "Precision", accessor: "val_precision", Cell: ({ value }) => formatCell(value) },
                    { Header: "Recall", accessor: "val_recall", Cell: ({ value }) => formatCell(value) },
                    { Header: "F-Score", accessor: "val_fscore", Cell: ({ value }) => formatCell(value) },
                    { Header: "Time", accessor: "val_time", Cell: ({ value }) => formatCell(value) },
                ]
            }
        ], []
    )

    return (
        <div className="overflow-x-auto">
            <div className="text-left text-lg text-gray-500 my-3">Epoch Details</div>
            <Table data={data} columns={columns} />
        </div>
    )
}

export default TrainingReportTableView
